<template>
  <div>
    <page-header title="Customer Profile" breadcrumb="Dashboard > Customer Engagement > Customer Profile "
      :back="{ name: 'CustomerEngagement' }" />
    <profile-card :contact="contact" @show-settings="currentTab = 'settings'" />
    <div class="flex mt-12 mb-3">
      <div class="tab-item " :class="{ active: currentTab == 'profile' }" @click="currentTab = 'profile'">
        <p>Profile</p>
      </div>
    
      <div class="tab-item" :class="{ active: currentTab == 'settings' }" @click="currentTab = 'settings'">
        <p>Settings</p>
      </div>
    </div>
    <keep-alive>
      <component :is="currentTab" :contact="contact" @contact-updated="getContactInformation"></component>
    </keep-alive>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import ProfileCard from "./ProfileCard";
import Profile from "./Tabs/Profile";
import Payments from "./Tabs/PaymentSettings";
import Transactions from "./Tabs/TransactionHistory";
import Settings from "./Tabs/Settings";

export default {
  components: {
    PageHeader,
    ProfileCard,
    Profile,
    Payments,
    Transactions,
    Settings,
  },
  data() {
    return {
      currentTab: "profile",
      contact: {},
      accountManagers: [],
    };
  },
  mounted() {
    this.getContactInformation();
  },
  methods: {
    async getContactInformation() {
      this.loading = true;
      const customerId = localStorage.getItem("customerId");
      if (!customerId) {
        this.$router.push({ name: "CRM" });
      }
      try {
        const response = await this.$_getSingleContact(customerId);
        console.log(response);
        this.contact = response.data.contact;
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;

  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #10233e;
    font-weight: bold;
  }
}
</style>
